import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from 'tss-react/mui';
import { useFeature } from 'flagged';
import PageTitle from '@helpers/PageTitle';
import GameAccounts from '@domain/User/Profile/components/GameAccounts';
import { useUserState } from '@context/UserContext';
import Help from './components/Help';
import HelpWinddown from './components/HelpWinddown';
import { TournamentBanner, Container } from './styles';
const useStyles = makeStyles()((theme) => ({
    leftColumn: {
        display: 'grid',
        gridAutoRows: 'min-content',
        [theme.breakpoints.down('lg')]: {
            paddingBottom: '20px',
        },
    },
    rightColumn: {
        display: 'grid',
        gridAutoRows: 'min-content',
        [theme.breakpoints.down('md')]: {
            gap: '20px',
        },
        padding: theme.spacing(3),
    },
}));
const AccountGames = () => {
    const isWithdrawalOnlyEnabled = !!useFeature('semisonic_phase_2');
    const { userProfile } = useUserState();
    const { classes } = useStyles();
    return (_jsx(TournamentBanner, { children: _jsxs(Container, { children: [_jsx(PageTitle, {}), _jsx("div", { className: classes.leftColumn, children: _jsx(GameAccounts, { isCurrentUser: true, userHandle: userProfile === null || userProfile === void 0 ? void 0 : userProfile.handle }) }), isWithdrawalOnlyEnabled ? _jsx(HelpWinddown, {}) : _jsx(Help, {})] }) }));
};
export default AccountGames;
